import ModelValidator from 'lib/ModelValidator';

export default function paymentValidator(values) {
  const validator = new ModelValidator(values);

  return validator.getAllErrors({
    "termsAccepted":    ['accepted'],
  });
};
